const initialState = {
  isExpanded: true,
};

// Action Type
const TOGGLE_EXPANDED = 'TOGGLE_EXPANDED';

// Action Creator
export const toggleExpanded = () => ({
  type: TOGGLE_EXPANDED,
});

// Reducer
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_EXPANDED:
      return { ...state, isExpanded: !state.isExpanded };
    default:
      return state;
  }
};
